import { useMemo, useState } from "react";
import useUrlParamState from "hooks/useUrlParamState";
import { SignInPages } from "./signInTools";

export interface SignInData {
  signInMethod?: string;
  email: string;
  password: string;
}

export interface SignInPagesProps {
  signInData: SignInData;
  setSignInData: React.Dispatch<React.SetStateAction<SignInData>>;
}

interface LoginProps {}

const SignIn: React.FC<LoginProps> = () => {
  const [currentPage] = useUrlParamState("currentPage", "signInMethod");

  const [chargerEstimatorData, setChargerEstimatorData] = useState<SignInData>({
    email: "",
    password: "",
  });

  const currentPageComponent = useMemo(() => {
    return SignInPages.find((page) => page.pageName === currentPage);
  }, [currentPage]);

  return (
    <>
      {currentPageComponent?.component(
        chargerEstimatorData,
        setChargerEstimatorData,
      )}
    </>
  );
};

export default SignIn;
